{
  "name": "feedback",
  "version": "1.0.2-beta-65-g3ccebf0.0.5",
  "engines": {
    "node": "^24.15.0"
  },
  "scripts": {
    "prepare": "node ../../scripts/setup-git-hooks.mjs",
    "ng": "ng",
    "test": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng test",
    "start-app": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng serve feedback-app --configuration local",
    "build-app": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build feedback-app",
    "watch-app": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build feedback-app --watch --configuration development",
    "build-api": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build feedback-api",
    "watch-api": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build feedback-api --watch --configuration development",
    "build-components": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build feedback-components",
    "watch-components": "cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build feedback-components --watch --configuration development",
    "build-libs": "npm run build-api && npm run build-components",
    "build-dev": "npm run build-libs && cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build feedback-app --configuration development",
    "build-staging": "npm run build-libs && cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build feedback-app --configuration staging",
    "build-prod": "npm run build-libs && cross-env NODE_OPTIONS=--max_old_space_size=8192 ng build feedback-app --configuration production",
    "watch-libs": "concurrently -n api,components -c blue,magenta \"npm:watch-api\" \"npm:watch-components\"",
    "dev": "concurrently -n api,components,app -c blue,magenta,green \"npm:watch-api\" \"npm:watch-components\" \"npm:start-app\"",
    "start-dev": "node ../../scripts/start-dev.mjs",
    "test-auth-bridge": "node tools/auth-bridge-test/serve.mjs",
    "br": "br"
  },
  "private": true,
  "packageManager": "npm@11.17.0",
  "dependencies": {
    "@angular/cdk": "^22.1.0",
    "@angular/common": "^22.1.0",
    "@angular/compiler": "^22.1.0",
    "@angular/core": "^22.1.0",
    "@angular/forms": "^22.1.0",
    "@angular/material": "^22.1.0",
    "@angular/platform-browser": "^22.1.0",
    "@angular/router": "^22.1.0",
    "@brafton/angular-styles-library": "^2.2.2-alpha-233-g512da9d.0.104",
    "@brafton/skynet-angular-security-service": "8.3.2-alpha-47-gd8914ba.0.27",
    "events": "^3.3.0",
    "moment": "^2.30.1",
    "ngx-moment": "^6.0.2",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^22.1.2",
    "@angular/cli": "^22.1.2",
    "@angular/compiler-cli": "^22.1.0",
    "@types/auth0-js": "9.14.4",
    "@types/auth0-lock": "11.27.4",
    "concurrently": "^9.2.1",
    "cross-env": "^7.0.3",
    "jsdom": "^28.0.0",
    "ng-packagr": "^22.1.0",
    "playwright": "^1.60.0",
    "prettier": "^3.8.1",
    "typescript": "~6.0.3",
    "vitest": "^4.0.8"
  }
}
